export default {
  'footer': {
    'confirm': '@:terms.confirm',
    'ok': '예',
    'no': '아니요',
    'cancel': '취소',
    'close': '닫기',
  },
}
